export var productMediaFromImages = function(images) {
    return images.map(function(image, index) {
        return {
            image: image,
            index: index,
            isVideo: false
        };
    });
};
export var getMediaToken = function(media) {
    if (media) {
        return media.isVideo ? media.video.token : media.image.token;
    }
    return undefined;
};
